module.exports = __webpack_public_path__ + "static/media/noAddress.837f93c5.png";